import { Component,OnInit,OnDestroy,AfterViewInit,Input,Output,EventEmitter } from '@angular/core';
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { takeWhile } from "rxjs/operators";

import {
    FvmsCommonService
    ,FvmsApiDtgReportCarService
    ,FvmsApiAuthService
    ,FvmsExcelService
} from "src/app/shared/service";
import {
    PagingInfo
    ,DtgActionType
    ,DtgListType
} from "src/app/shared/vo";
import {
    FilterDist
    ,FilterDateDiff
    ,FilterSecToTime
} from "src/app/shared/filter";

@Component({
    selector: "dtg-report-car-trip-detail-list"
    ,templateUrl: './dtg.report.car.trip.detail.list.component.html'
    ,providers:[FilterDateDiff,FilterSecToTime,FilterDist]
})
export class DtgReportCarTripDetailListComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    companyInfo:any;
    currentUserInfo:any;
    pagingInfo:PagingInfo = new PagingInfo();
    dayDiff:number=0;
    listTeam:any[];
    searchValue:string;
    @Input() listType:DtgListType = DtgListType.list;
    @Input() dtgUnitId:string;
    @Input() fvmsTripCnt:string;
    DtgActionType = DtgActionType;
    DtgListType = DtgListType;
    userGroupId:number;
    dtgTeamId:string = "";
    
    constructor(
        private modalService: NgbModal
        ,private fvmsCommonService:FvmsCommonService
        ,private fvmsApiDtgReportCarService:FvmsApiDtgReportCarService
        ,private fvmsApiAuthService:FvmsApiAuthService
        ,private fvmsExcelService:FvmsExcelService
        ,private filterDist:FilterDist
    ) {
        this.companyInfo = this.fvmsCommonService.getCompanyInfo();
        this.currentUserInfo = this.fvmsApiAuthService.getLoginUserInfo();
        this.userGroupId = parseInt(this.currentUserInfo.userGroupId);
        this.pagingInfo.pageSize = 15;
     }

    ngOnInit() {
        this.reloadListItem();
    }

    ngOnDestroy() {
        this.isContinue = false;
    }
    
    ngAfterViewInit() {
        
    }

    reloadListItem(){
        let searchInfo = {
            companyId : this.companyInfo?.companyId || 0
            ,dtgUnitId:this.dtgUnitId
            ,fvmsTripCnt:this.fvmsTripCnt
        };
        this.fvmsApiDtgReportCarService.getListReportCarDetailInTrip(searchInfo,this.pagingInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                this.listTeam = []
                if(apiResponse.resultStatus === "ok"){
                    this.listTeam = apiResponse.resultValue;
                    this.pagingInfo = apiResponse.pagingInfo;
                    if(this.listTeam){
                        let sizeList = this.listTeam.length;
                        for(let a=0;a<sizeList;a++){
                            let item = this.listTeam[a];
                            item.dtgSpeed = Math.floor(item.dtgSpeed);
                        }
                    }
                }
            });
    }

    callbackClickPageNumber(pageNo: number) {
        this.pagingInfo.curPage=pageNo;
        this.reloadListItem();
    }

    callbackChangeCountRowPerPage(pageSize:number){
        this.pagingInfo.pageSize = pageSize;
        this.callbackClickPageNumber(1);
    }

    clickSearch(){
        this.reloadListItem();
    }

    exportExcel(){
        this.fvmsCommonService.setIsLoading(true);
        let searchInfo = {
            companyId : this.companyInfo?.companyId || 0
            ,dtgUnitId:this.dtgUnitId
            ,fvmsTripCnt:this.fvmsTripCnt
        };
        let paging = new PagingInfo();
        paging.pageSize=999999;
        this.fvmsApiDtgReportCarService.getListReportCarDetailInTrip(searchInfo,paging)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    let listItems = apiResponse.resultValue;
                    let listJson = this.convertExcelJson(listItems);
                    this.fvmsExcelService.excelDownload(listJson,"listGroup");
                    this.fvmsCommonService.setIsLoading(false);
                }
            });
    }

    convertExcelJson(dataList:any[]){
        return dataList.map((v,i) => {
            return {
                 "시간":v.dtgRegDt
                ,"누적운행거리(km)":this.filterDist.transform(v.dtgDistAccumul).toFixed(3)
                ,"트립운행거리(km)":this.filterDist.transform(v.dtgDistTrip).toFixed(3)
                ,"속도(km/h)": Math.floor(v.dtgSpeed)
                ,"RPM":v.dtgRpm
                ,"트립연료사용량(L)":v.dtgOilUseTrip
                ,"온도1(°C)":v.dtgTemper1
                ,"온도2(°C)":v.dtgTemper2
                ,"위치":v?.dtgGpsAddr || "-"
            };
        });
    }
}